import { useEffect, useState } from "react";

import {
	EVENTO_LAYOUT_TICKETS,
	lerLayoutTickets,
} from "../../services/layoutTickets";

// Cada tela que muda de forma conforme o layout chama isto e pronto — não há
// prop atravessando quatro componentes só para dizer "estamos no painel".
const useLayoutTickets = () => {
	const [layout, setLayout] = useState(lerLayoutTickets);

	useEffect(() => {
		const atualizar = () => setLayout(lerLayoutTickets());

		window.addEventListener(EVENTO_LAYOUT_TICKETS, atualizar);
		// Outra aba do mesmo navegador também muda o cookie.
		window.addEventListener("focus", atualizar);

		return () => {
			window.removeEventListener(EVENTO_LAYOUT_TICKETS, atualizar);
			window.removeEventListener("focus", atualizar);
		};
	}, []);

	return layout;
};

export default useLayoutTickets;
